import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BodyService {

  public isBlocked: boolean = false;

  /**
   * Event to prevent to move body.
   */
  public blockBody(): void {
    this.isBlocked = true;
    document.body.classList.add('overflow-hidden');
  }

  /**
   * Event to allow to move body.
   */
  public unlockBody(): void {
    this.isBlocked = false;
    document.body.classList.remove('overflow-hidden');
  }
}